import { render, staticRenderFns } from "./FamilyCreate.vue?vue&type=template&id=6a2a4b33&lang=pug&"
import script from "./FamilyCreate.vue?vue&type=script&lang=js&"
export * from "./FamilyCreate.vue?vue&type=script&lang=js&"
import style0 from "./FamilyCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FamilyCreate.vue"
export default component.exports